export const iconFontAwesomeSecurityFileShield = (
	<i className="fa-solid fa-file-shield"></i>
);
